const OrganizationCollectionFields = [
];

export default OrganizationCollectionFields;